import { createAction } from 'redux-actions';
export const SET_PASSENGERS = 'REFUND/SET_PASSENGERS';
export const SET_PASSENGER_SELECT = 'REFUND/SET_PASSENGER_SELECT';
export const SET_ALL_PASSENGER_SELECT = 'REFUND/SET_ALL_PASSENGER_SELECT';
export const setPassengers = createAction(SET_PASSENGERS);
export const setPassengerSelect = createAction(SET_PASSENGER_SELECT);
export const setAllPassengerSelect = createAction(SET_ALL_PASSENGER_SELECT);
